module.exports = __webpack_public_path__ + "img/logonavbar.2b0f72df.png";